<script lang="ts" setup>
import DataTableForm from '@/components/data-tables/DataTableForm.vue';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import { DataTablesActions, DataTablesState } from '@/stores/data-tables.store';
import { DataTable } from '@/models/data-table.model';

const store = useStore<ShiftCMSState & { ds: DataTablesState }>();
const dataTables = computed<DataTable[]>(() => store.state.ds.dataTables);

const update = () => {
  store.dispatch(DataTablesActions.GetDataTables);
};

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const editDataTable = (_: Event, { item }: { item: DataTable }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(DataTableForm),
    data: item,
  });
};

const addDataTable = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(DataTableForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Name', key: 'name', width: '10%' },
  { title: 'Data', key: 'data' },
  { title: 'Date', key: 'creationDate', width: '20%' },
];
</script>

<template>
  <v-container>
    <h2>Data Tables</h2>

    <v-alert type="warning" density="compact" class="mb-8 mt-8"
      >Please be careful editing this data. It is used in the CO2
      calculations.</v-alert
    >
    <v-data-table
      density="compact"
      @click:row="editDataTable"
      :headers="headers"
      :items="dataTables"
      itemsPerPage="25"
      hover
    >
      <template v-slot:item.creationDate="{ value }">
        {{ format(value, 'do MMMM yyyy - HH:mm') }}
      </template>
      <template v-slot:item.data="{ value }">
        {{
          Array.isArray(value)
            ? `${value.length} rows`
            : `${Object.keys(value).length} fields`
        }}
      </template>
    </v-data-table>

    <v-btn @click="addDataTable" color="success">Add DataTable</v-btn>
  </v-container>
</template>
